<div mat-dialog-content class="font-update">
    <p class="info">{{ data.message }}</p>
    <p>{{ "confirmationMesage" | translate }}</p>
</div>
<div mat-dialog-actions class="font-update">
    <button mat-raised-button class="cancel-payment" (click)="cancelPayment()">
        {{ "button.cancel" | translate }}
    </button>
    <button
        mat-raised-button
        [disabled]="isSubmiting"
        (click)="acceptPayment()"
    >
        <app-loading *ngIf="isSubmiting"></app-loading>
        {{ "button.buttonSubmit" | translate }}
    </button>
</div>
